const currentClinicalProfile = state => {
  if (!state.currentClinicalProfile) return

  const {
    height = 0,
    weight = 0,
    abdominalCircumference = 0
  } = state.currentClinicalProfile
  const imc =
    Math.round((Number(weight) / (Number(height) * Number(height))) * 100) / 100
  const absByHeight = (
    (Number(abdominalCircumference) * 0.01) /
    Number(height)
  ).toFixed(2)

  return {
    ...state.currentClinicalProfile,
    imc: isNaN(imc) ? 0 : imc,
    absByHeight: isNaN(absByHeight) ? 0 : absByHeight
  }
}

const currentClinicalProfileVersion = state =>
  state.currentClinicalProfile.version

const healthMeasurements = state => state.healthMeasurements

const healthMeasurementTypes = state => state.healthMeasurementTypes

export default {
  currentClinicalProfile,
  currentClinicalProfileVersion,
  healthMeasurements,
  healthMeasurementTypes
}
